import styled, { css } from 'styled-components';
import { transparentize } from 'polished';

export const Wrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray.light};
  padding-top: ${({ theme }) => theme.space[5]}px;
`;

export const List = styled.ul`
  list-style: none;
  padding: ${({ theme }) => theme.space[6]}px;
  border-radius: ${({ theme }) => theme.radii[3]}px;
  border: 1px solid ${({ theme }) => theme.colors.gray.extraLight};
  ${({ theme }) => css`
    box-shadow: 0 8px 16px ${transparentize(0.85, theme?.colors?.black?.dark)};
  `};
`;
